/**
 * App Frame Component
 *
 * Main layout with navigation for the embedded app.
 * Uses Polaris Frame and Navigation components.
 */

import { Frame, Navigation } from '@shopify/polaris';
import {
  HomeIcon,
  ProductIcon,
  WandIcon,
  SettingsIcon,
} from '@shopify/polaris-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import type { ReactNode } from 'react';

interface AppFrameProps {
  children: ReactNode;
}

export function AppFrame({ children }: AppFrameProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const navigationMarkup = (
    <Navigation location={location.pathname}>
      <Navigation.Section
        items={[
          {
            url: '/dashboard',
            label: 'Dashboard',
            icon: HomeIcon,
            selected: location.pathname === '/dashboard',
            onClick: () => navigate('/dashboard'),
          },
          {
            url: '/products',
            label: 'Produkte',
            icon: ProductIcon,
            selected: location.pathname === '/products',
            onClick: () => navigate('/products'),
          },
          {
            url: '/optimize',
            label: 'Optimieren',
            icon: WandIcon,
            selected: location.pathname === '/optimize',
            onClick: () => navigate('/optimize'),
          },
          {
            url: '/settings',
            label: 'Einstellungen',
            icon: SettingsIcon,
            selected: location.pathname === '/settings',
            onClick: () => navigate('/settings'),
          },
        ]}
      />
    </Navigation>
  );

  return (
    <Frame navigation={navigationMarkup}>
      {children}
    </Frame>
  );
}
